import { IconButton, Paper, styled } from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  ...theme.typography.body2,
  padding: theme.spacing(1),
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),
  color: theme.palette.primary.contrastText,
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
}));

export const UploadedFileItem = ({ fileName, onClickDeleteButton }) => {
  return (
    <Item>
      {fileName}
      <IconButton size="small" onClick={onClickDeleteButton}>
        <ClearIcon sx={{color: 'primary.contrastText'}} />
      </IconButton>
    </Item>
  );
};
